/**
 * 救援推送管理设置（存于 system_settings.ui_settings.rescuePushSettings）
 */

export const DEFAULT_RESCUE_PUSH_SETTINGS = {
  defaultIcon: 'flag',
  defaultLevel: '普通',
  pickPointTtlMinutes: 30,
  trackerTtlDays: 30
};

function clampInt(value, fallback, min, max) {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(max, Math.max(min, Math.round(number)));
}

export function normalizeRescuePushSettings(raw = {}) {
  const icon = String(raw?.defaultIcon || DEFAULT_RESCUE_PUSH_SETTINGS.defaultIcon).trim() || 'flag';
  const level = raw?.defaultLevel === '紧急' ? '紧急' : '普通';
  return {
    defaultIcon: icon,
    defaultLevel: level,
    pickPointTtlMinutes: clampInt(
      raw?.pickPointTtlMinutes,
      DEFAULT_RESCUE_PUSH_SETTINGS.pickPointTtlMinutes,
      5,
      120
    ),
    trackerTtlDays: clampInt(
      raw?.trackerTtlDays,
      DEFAULT_RESCUE_PUSH_SETTINGS.trackerTtlDays,
      0,
      365
    )
  };
}
